import React from 'react'
import { Box, Button, FormControl } from '@mui/material'
import { useRoleResponsibilityLuts } from 'components'

interface ResponsibilityMultiSelectProps {
  value: number[]
  onChange: (selectedIds: number[]) => void
  disabled?: boolean
}

export const ResponsibilityMultiSelect: React.FC<ResponsibilityMultiSelectProps> = ({ value, onChange, disabled = false }) => {
  const { lutValues: roleResponsibilityLutValues } = useRoleResponsibilityLuts()

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedValues = Array.from(event.target.selectedOptions).map(option => Number(option.value))
    onChange(selectedValues)
  }

  const handleClear = (): void => {
    onChange([])
  }

  const sortedResponsibilities = Array.from(roleResponsibilityLutValues.responsibilities.values())
    .sort((a, b) => a.lutOrder - b.lutOrder)

  return (
    <div>
      <FormControl fullWidth sx={{ height: 200 }}>
        <select
          disabled={disabled}
          multiple
          id="select-multiple-native"
          value={value.map(String)}
          onChange={handleChange}
          style={{
            height: '160px',
            width: '100%',
            overflowY: 'auto'
          }}
        >
          {sortedResponsibilities.map((responsibility) => (
            <option key={responsibility.id} value={responsibility.id.toString()}>
              {responsibility.descShort}
            </option>
          ))}
        </select>
        {value.length > 0 && !disabled && (
          // A plain text button (not an X icon) so this field-level "clear the
          // selection" action can't be mistaken for the form-level Cancel.
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <Button size="small" onClick={handleClear}>Clear all</Button>
          </Box>
        )}
      </FormControl>
    </div>
  )
}
